// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelGuideTeaser_root__itWYn","cardBody":"TravelGuideTeaser_cardBody__VfQ6Y","cardTitle":"TravelGuideTeaser_cardTitle__KZqVF"};